import React from "react";
import PropTypes from "prop-types";
import useDownload from "hooks/useDownload";
import DocumentActionButton from "components/helpers/DocumentActionButton";

export default function DocumentDownloadButton({
  documentId,
  antivirusStatus,
  antivirusThreats,
  children,
  className,
  asLink,
}) {
  const { handleDownload, isLoading } = useDownload(documentId);

  return (
    <DocumentActionButton
      onAction={handleDownload}
      isLoading={isLoading}
      antivirusStatus={antivirusStatus}
      antivirusThreats={antivirusThreats}
      className={className}
      asLink={asLink}
    >
      {children}
    </DocumentActionButton>
  );
}

DocumentDownloadButton.propTypes = {
  documentId: PropTypes.number.isRequired,
  antivirusStatus: PropTypes.string,
  antivirusThreats: PropTypes.array,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  asLink: PropTypes.bool,
};
